// extracted by mini-css-extract-plugin
export var createdDate = "_nh-1";
export var divider = "_nh-2";
export var headerDivider = "_nh-3";
export var messagesCard = "_nh-0";
export var messagesContainer = "_nh-6";
export var messagesContainerWrapper = "_nh-4";
export var showLeftPanelButton = "_nh-8";
export var topButtons = "_nh-7";
export var withPadding = "_nh-5";